import { QuickResolveActionItem } from '@hakimo-ui/hakimo/types';
import { MenuDropdown, ShieldIcon } from '@hakimo-ui/hakimo/ui-elements';
import { Button, Tooltip } from '@hakimo-ui/shared/ui-base';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import {
  ExclamationTriangleIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { getQuickResolveActionLabel } from '../sop-manager/type-guards';

interface ActionsRowProps {
  quickResolveActions?: QuickResolveActionItem[];
  onQuickResolve?: (comment: string, action?: QuickResolveActionItem) => void;
  onEscalate: () => void;
  isZeroToleranceSite?: boolean;
  disabled?: boolean;
}

export function ActionsRow(props: ActionsRowProps) {
  const {
    quickResolveActions,
    onQuickResolve,
    onEscalate,
    isZeroToleranceSite,
    disabled,
  } = props;

  const canMarkSafe = !isZeroToleranceSite && !disabled;

  return (
    <div
      className={clsx(
        'py-2',
        isZeroToleranceSite && 'bg-alert-600 -mx-5 -mt-2  px-5 py-3'
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {isZeroToleranceSite && (
            <div className="flex items-center gap-2">
              <ShieldIcon className="h-6 w-6 text-white" />
              <span className="font-medium text-white">Zero Tolerance</span>
            </div>
          )}
          {canMarkSafe && (
            <QuickSafeMenu
              quickResolveActions={quickResolveActions}
              onQuickResolve={onQuickResolve}
            />
          )}
        </div>

        <Button
          variant="error"
          onClick={onEscalate}
          disabled={disabled}
          className={clsx(
            isZeroToleranceSite &&
              '!text-alert-600 hover:!bg-onlight-bg-2 !bg-white font-semibold'
          )}
        >
          <span className="block xl:hidden">
            <Tooltip text="Escalate" position="bottom">
              <ExclamationTriangleIcon className="-m-2 h-5 w-5" />
            </Tooltip>
          </span>
          <span className="hidden xl:block">Escalate</span>
        </Button>
      </div>
    </div>
  );
}

interface QuickSafeMenuProps {
  quickResolveActions?: QuickResolveActionItem[];
  onQuickResolve?: (comment: string, action?: QuickResolveActionItem) => void;
}

function QuickSafeMenu(props: QuickSafeMenuProps) {
  const { quickResolveActions, onQuickResolve } = props;

  const menuButton = (
    <div className="bg-primary-500 hover:bg-primary-600 dark:bg-primary-600 dark:hover:bg-primary-700 text-dark-text flex cursor-pointer items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium">
      <span className="block xl:hidden">
        <Tooltip text="Safe" position="bottom">
          <ShieldCheckIcon className="-m-2 h-5 w-5" />
        </Tooltip>
      </span>
      <span className="hidden xl:block">Safe</span>
      <ChevronDownIcon className="h-4 w-4" />
    </div>
  );

  const items =
    quickResolveActions?.map((action) => ({
      name: getQuickResolveActionLabel(action),
      onClick: () =>
        onQuickResolve?.(getQuickResolveActionLabel(action), action),
    })) ?? [];

  return (
    <MenuDropdown
      position="bottom-right"
      items={items}
      menuButton={menuButton}
      useOnlyMenuButtonNode
    />
  );
}

export default ActionsRow;
